"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchMiddleware = void 0;
const common_1 = require("../common");
const ContentType = "content-type";
const ApplicationJson = "application/json";
const TextPlain = "text/plain";
const TextHtml = "text/html";
class FetchMiddleware {
    async onRequest(req) {
        const response = await fetch(req.url, {
            method: req.method,
            headers: req.headers,
            body: req.headers?.[ContentType]?.startsWith(ApplicationJson) ? JSON.stringify(req.body) : req.body,
        });
        let body = await response.text();
        const contentType = response.headers.get(ContentType);
        if (body && contentType && !contentType?.includes(TextPlain) && !contentType?.includes(TextHtml)) {
            try {
                body = JSON.parse(body);
            }
            catch (error) {
                throw new common_1.JsonParsingError(body, error);
            }
        }
        return {
            method: req.method,
            url: req.url,
            path: req.path,
            headers: Object.fromEntries(response.headers),
            params: req.params,
            query: req.query,
            body: body,
            statusCode: response.status,
        };
    }
}
exports.FetchMiddleware = FetchMiddleware;
//# sourceMappingURL=fetch.middleware.js.map